import { render, staticRenderFns } from "./wine-collections-investor2.vue?vue&type=template&id=dd6b3acc&scoped=true"
import script from "./wine-collections-investor2.vue?vue&type=script&lang=js"
export * from "./wine-collections-investor2.vue?vue&type=script&lang=js"
import style0 from "./wine-collections-investor2.vue?vue&type=style&index=0&id=dd6b3acc&prod&scoped=true&lang=css"
import style1 from "./wine-collections-investor2.vue?vue&type=style&index=1&id=dd6b3acc&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6b3acc",
  null
  
)

export default component.exports